import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ConfigurationComponent } from './configuration/configuration.component';
import { ConfigurationsComponent } from './configurations.component';






const routes: Routes = [
 {path :"",component:ConfigurationsComponent ,children:[
   {path:"Configuration",component:ConfigurationComponent},
   {path:"", redirectTo: 'Configuration', pathMatch: 'full'},

 
 ]}
 
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
exports: [RouterModule]
})
export class ConfigurationsRoutingModule { }
